import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class ConnectedServiceService {
  baseUrl = 'connected-service';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = () => BaseService.get({ url: `${this.baseUrl}/get-list` });
  sync = (dto) => BaseService.post({ url: `${this.baseUrl}/sync`, data: dto });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (dto) => BaseService.post({ url: `${this.baseUrl}/save`, data: dto });
}

export default new ConnectedServiceService()
